var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1SendMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 22v33h51V22H25zm44 4L50.77 39.12 32.34 26H69zm-40 2.53L40.86 37 29 46.68V28.53zM30 51l14.23-11.62L50.78 44l6.53-4.69L71.54 51H30zm42-4.8l-11.32-9.27L72 28.81V46.2zM8 40h14v4H8v-4zm7-4.1H0V32h15v3.9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Send_mail.8dcc3164.svg";
export { SvgH1SendMail as ReactComponent };